import DutiesPage from './DutiesPage';

export default DutiesPage;
